import { render, staticRenderFns } from "./SocialProof.vue?vue&type=template&id=4c281b3c&scoped=true"
import script from "./SocialProof.vue?vue&type=script&lang=ts"
export * from "./SocialProof.vue?vue&type=script&lang=ts"
import style0 from "./SocialProof.vue?vue&type=style&index=0&id=4c281b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c281b3c",
  null
  
)

export default component.exports